<div class="me-payment-form">
    <div tabindex="0" class="me-payment-form__header">
        {{ 'Payment' | translate}}
    </div>
    <div tabindex="0" class="me-payment-form__description">
        {{ 'We will send you an invoice by email.' | translate}}
    </div>
    <form [formGroup]="form">
        <div class="row">
            <div class="col-xs-6">
                <div class="me-form-input-group">
                    <div class="me-form-input" [class.error]="!(form.controls.first_name.valid
                    || (form.controls.first_name.pristine && !submitted))">
                        <label class="me-form-input__label">{{'Given Name' | translate}}*</label>
                        <input title="{{'Please fill out this field.' | translate}}" [attr.aria-label]="'Given Name' | translate" formControlName="first_name" class="me-form-input__input" />
                    </div>
                    <small [hidden]="form.controls.first_name.valid
                    || (form.controls.first_name.pristine && !submitted)"
                    class="me-form-input__error">
                        {{ 'This field is required.' | translate }}
                    </small>
                </div>
            </div>
            <div class="col-xs-6">
                <div class="me-form-input-group">
                    <div class="me-form-input" [class.error]="!(form.controls.last_name.valid
                    || (form.controls.last_name.pristine && !submitted))">
                        <label class="me-form-input__label">{{ 'Last Name' | translate }}*</label>
                        <input title="{{'Please fill out this field.' | translate}}" [attr.aria-label]="'Last Name' | translate" formControlName="last_name" class="me-form-input__input" />
                    </div>
                    <small [hidden]="form.controls.last_name.valid
                    || (form.controls.last_name.pristine && !submitted)"
                    class="me-form-input__error">
                        {{ 'This field is required.' | translate }}
                    </small>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="me-form-input-group">
                    <div class="me-form-input" [class.error]="!(form.controls.street.valid
                    || (form.controls.street.pristine && !submitted))">
                        <label class="me-form-input__label">{{ 'Address' | translate }}*</label>
                        <input title="{{'Please fill out this field.' | translate}}" [attr.aria-label]="'Address' | translate" formControlName="street" class="me-form-input__input" />
                    </div>
                    <small [hidden]="form.controls.street.valid
                    || (form.controls.street.pristine && !submitted)"
                    class="me-form-input__error">
                        {{ 'This field is required.' | translate }}
                    </small>
                </div>
            </div>
            <div class="col-xs-6">
                <div class="me-form-input-group">
                    <div class="me-form-input" [class.error]="!(form.controls.postal_code.valid
                    || (form.controls.postal_code.pristine && !submitted))">
                        <label class="me-form-input__label">{{ 'Zip code' | translate }}*</label>
                        <input title="{{'Please fill out this field.' | translate}}" [attr.aria-label]="'Zip code' | translate" formControlName="postal_code" class="me-form-input__input" />
                    </div>
                    <small [hidden]="form.controls.postal_code.valid
                    || (form.controls.postal_code.pristine && !submitted)"
                    class="me-form-input__error">
                        {{ 'This field is required.' | translate }}
                    </small>
                </div>
            </div>
            <div class="col-xs-6">
                <div class="me-form-input-group">
                    <div class="me-form-input" [class.error]="!(form.controls.city.valid
                    || (form.controls.city.pristine && !submitted))">
                        <label class="me-form-input__label">{{ 'City' | translate }}*</label>
                        <input title="{{'Please fill out this field.' | translate}}" [attr.aria-label]="'City' | translate" formControlName="city" class="me-form-input__input" />
                    </div>
                    <small [hidden]="form.controls.city.valid
                    || (form.controls.city.pristine && !submitted)"
                    class="me-form-input__error">
                        {{ 'This field is required.' | translate }}
                    </small>
                </div>
            </div>
            <div class="col-xs-12 mt-1">
                <mat-slide-toggle class="mat-me-toggle" formControlName="save_billing_information">
                    {{ 'Save my billing address for later' | translate}}
                </mat-slide-toggle>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-xs-12 mt-1">
            <mat-slide-toggle class="mat-me-toggle" [(ngModel)]="checked">
                {{ 'Accept' | translate}}
                <a class="link" href="me/policies/terms-of-use" target="_blank">{{ 'terms of use' | translate}}</a>
            </mat-slide-toggle>
        </div>
    </div>
    <div class="me-payment-form__button">
        <button class="btn btn--primary" [class.disabled]="!form.valid || !checked" (click)="submit(form.value, form.valid)">
            {{'Order' | translate}}
        </button>
    </div>
</div>